module.exports = __webpack_public_path__ + "static/media/stock-03.9412fcae.jpg";